import { dcb } from '@dcb/jssdk'
import {
  getCurrentInstance,
  onBeforeUnmount,
  Ref,
  watch,
} from '@vue/composition-api'

let i = 0

export function useNewRoute(value: Ref<boolean>) {
  // 对多彩宝 iOS 客户端不生效
  if (dcb.getEnvSync().dcb && dcb.getEnvSync().ios) return

  const flag = `_n${i++}_`

  const ctx = getCurrentInstance()!.root.proxy!

  const pageName = ctx.$route.name

  const offWatcher = watch(
    value,
    (value: boolean) => {
      if (value) {
        // 值为 true 且未进入时进入
        if (!ctx.$route.query[flag]) {
          ctx.$router.push({
            ...ctx.$route.query,
            query: {
              ...ctx.$route.query,
              [flag]: '1',
            },
          })
        }
      } else {
        // 值为 false 且已进入时返回
        if (ctx.$route.query[flag]) {
          ctx.$router.back()
        }
      }
    },
    {
      immediate: true,
    },
  )

  const offFlagWatcher = watch(
    () => ctx.$route,
    (route: typeof ctx.$route) => {
      if (route.name === pageName) {
        if (!route.query[flag]) {
          if (value.value) {
            value.value = false
          }
        } else {
          value.value = true
        }
      }
    },
    {
      immediate: true,
    },
  )

  onBeforeUnmount(() => {
    offWatcher()
    offFlagWatcher()
  })
}
